import { render, staticRenderFns } from "./Manager.vue?vue&type=template&id=3c5b2088&"
import script from "./Manager.vue?vue&type=script&lang=js&"
export * from "./Manager.vue?vue&type=script&lang=js&"
import style0 from "./Manager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports